import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
    KeyboardArrowLeft,
} from '@material-ui/icons';
import {
    inject, observer,
} from 'mobx-react';
import {
    WithSnackbarProps,
} from 'notistack';
import React, {
    Component,
} from 'react';
import {
    RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
    FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
    getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
    translate,
} from '../../helperFunctions/translation';
import {
    ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';

import {
    CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditFacilityGroup.module.scss';
import {countriesIsoCodes} from '../../constants/countries';
import {facilityTypes} from '../facilitiesMangementScreen/facilities';
import queryString from 'query-string';
import {IFacilityGroupStore} from "../../mobx-store/storeInterfaces/facilityGroupsInterface";
import {IFacilitiesAreasStore} from "../../mobx-store/storeInterfaces/facilityAreaInterface";

interface IProps extends WithSnackbarProps {
    facilityAreaStore: IFacilitiesAreasStore;
    facilityGroupStore: IFacilityGroupStore;
    countryStore: CountryStore;
    match: any;
    history: any;
}

interface IState {
    formFields: FormField[];
    loading: boolean;
    loadingManagedCountries: boolean;
    processing: boolean;
    selectedLang: string;
    facilityGroupType: any;
}

@inject('facilityGroupStore')
@inject('facilityAreaStore')
@inject('countryStore')
@observer
export class AddEditFacilityGroup extends Component<IProps & RouteComponentProps, IState> {
    isNew = false;

    isEgypt = true;

    GroupId = -1;

    facilityAreaId: 0;

    pageTitle = '';

    lastHistory = -1;

    GroupFormTitle = '';

    GroupSchema: any;

    submitButton: any;

    cancelButton: any;

    dropdownLanguages: {
        langList: { langCode: string; langValue: string } [];
        selectedLang: string;
        label: string;
        onChange(langCode: string): any;
    } | null = null;

    constructor(props: IProps & RouteComponentProps) {
        super(props);
        this.initializeComponent(props);
    }

    initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
        if (props.match.params.id) {
            this.isNew = false;
            this.GroupId = props.match.params.id;
            this.pageTitle = translate('editFacilityGroupPageTitle', {});
        } else {
            this.isNew = true;
            this.pageTitle = translate('addFacilityGroupPageTitle', {});
        }
        this.initGroupSchema();

        this.state = {
            selectedLang: this.isNew && this.isEgypt
                ? languageCodes.arabic : languageCodes.english,
            processing: false,
            loadingManagedCountries: !this.isNew,
            loading: !this.isNew,
            facilityGroupType: this.getQueryParam(),
            formFields: [],
        };

        this.setState({
            loading: true,
        }, () => {
            this.setState({
                formFields: this.getFOrmFields(),
            }, () => {
                this.setState({
                    loading: false,
                    loadingManagedCountries: false,
                });
            });
        });

        this.submitButton = this.getSubmitButton();
        this.cancelButton = this.getCancelButton();
        this.GroupFormTitle = translate('facilityGroupFormTitle', {});
        this.dropdownLanguages = this.getDropdownLanguages();
    }

    getDropdownLanguages = () => {
        if (this.isNew) {
            return null;
        }
        return {
            langList: getDropdownLanguagesList(),
            selectedLang: this.isEgypt ? languageCodes.english : this.state.selectedLang,
            label: 'Select Languages',
            onChange: this.handelLanguageChange,
        };
    };

    componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.lastHistory = -2;
            this.initializeComponent(nextProps, false);
            this.setState({
                loadingManagedCountries: false,
                facilityGroupType: this.getQueryParam(),
            });
            this.forceUpdate();
            if (!this.isNew) {
                const {
                    countryStore, facilityGroupStore,facilityAreaStore
                } = this.props;

                Promise.all([
                    facilityAreaStore.getFacilityAreas(countryStore.managedCountries),
                    facilityGroupStore.getFacilityGroupById(this.GroupId, languageCodes.english)
                ]).then(() => {
                    this.updateStateWithGroupData();
                    this.updateStateWithFacilityAreasData();
                });

            }
        }
    }

    handelLanguageChange = (langCode: string) => {
        if (langCode !== this.state.selectedLang) {
            this.setState({selectedLang: langCode}, () => {
                this.setState({
                    formFields: this.getFOrmFields()
                });
                if (!this.isNew) {
                    this.getFacilityGroup(langCode);
                }
            });
        }
    };

    initGroupSchema = () => {
        this.GroupSchema = Yup.object().shape({
            title: Yup.string().required('Required'),
            isActive: Yup.boolean().default(true),
            imageUrl: Yup.array(),
            facilityArea: Yup.number().required('Required'),
        });
    };

    getFOrmFields = (): FormField[] => {
        const formFields: FormField[] = [
            {
                name: 'title',
                label: this.state?.selectedLang === languageCodes.arabic ? translate('editFacilityGroupArabicTitle', {}) : translate('editFacilityGroupEnglishTitle', {}),
                type: 'text',
                filedType: 'InputField',
            },
            {
                name: 'facilityArea',
                label: translate('FacilityPageFormFacilityAreas', {}),
                selectList: [],
                selectListValue: 'title',
                selectListKey: 'facilityAreaId',
                filedType: 'DropdownField',

            },
            {
                name: 'imageUrl',
                label: translate('addFacilityGroupImage', {}),
                filedType: 'GalleryField',
                isLimitToOneImage: true,
                accept: 'image/*',
                size: 200,
            },
            {
                name: 'isActive',
                label: translate('addFacilityGroupPageFormStatus', {}),
                filedType: 'ToggleButtonField',
                activeLabel: translate('facilitiesGroupsListStatusActive', {}),
                inactiveLabel: translate('facilitiesGroupsListStatusInActive', {}),
                value: true,
            },
        ];
        const queryType = this.getQueryParam();
        if (queryType === facilityTypes.MARKETING) {
            return formFields.filter((formField: FormField) => {
                return formField.name !== 'imageUrl';
            })
        }
        return formFields;
    };

    navigateBack = () => {
        this.props.history.goBack();
    };

    handleSubmit = (values: any): void => {
        const {
            countryStore,
        } = this.props;
        values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);
        values.type = this.state.facilityGroupType;

        this.setState({
            processing: true,
        });
        if (this.isNew) {
            try {
                this.props.facilityGroupStore.createFacilityGroup(values)
                    .then((FacilityGroupId) => {
                        if (this.isEgypt) {
                            this.props.history.push(`${FacilityGroupId}/edit`);
                        } else {
                            this.props.history.go(this.lastHistory);
                        }
                    });
            } catch {
                this.setState({
                    processing: false,
                });
                SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {}), 5000, 'error');
            }
        } else {
            this.props.facilityGroupStore.updateFacilityGroup(values, this.GroupId, this.state.selectedLang)
                .then(() => {
                    this.setState({
                        processing: false,
                    });
                    SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {}), 5000, 'success');
                    this.props.history.go(this.lastHistory);
                }).catch(() => {
                this.setState({
                    processing: false,
                });
                SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {}), 5000, 'error');
            });
        }
    };

    getSubmitButton = () => ({
        title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
        onSubmit: this.handleSubmit,
    });

    getCancelButton = () => ({
        title: 'Cancel',
        onCancel: this.navigateBack,
    });

    updateStateWithGroupData = () => {
        const formFieldsWithData = [];
        for (const field of this.state.formFields) {
            formFieldsWithData.push({
                ...field, value: this.props.facilityGroupStore.selectedGroup[field.name],
            });
        }
        this.setState({
            formFields: formFieldsWithData, loading: false,
        });
    };
    updateAreasNames = () => {
        const areas = this.props.facilityAreaStore.facilitiesAreas.map(area => {
            return {
                ...area,
                title: `${area.title} - ${area.branch.title}`
            }
        });
        return areas;
    };

    updateStateWithFacilityAreasData = () => {
        const formFieldsWithData = [];
        const areas = this.updateAreasNames();

        for (const field of this.state.formFields) {
            if (field.name === 'facilityArea') {
                formFieldsWithData.push(
                    {
                        ...field,
                        selectList: areas,
                    },
                );
            } else {
                formFieldsWithData.push(field);
            }
        }
        this.setState({
            formFields: formFieldsWithData,
            loading: false,
        });
    };

    getFormPageHeader = () => (
        <div className={classes.header}>
            {this.isNew
                && (
                    <IconButton
                        className={classes.backButton}
                        onClick={() => this.props.history.goBack()}
                        aria-label="Back"
                    >
                        <KeyboardArrowLeft/>
                    </IconButton>
                )}
            <Typography className={classes.title} variant="h6" gutterBottom>
                {this.pageTitle}
            </Typography>
        </div>
    );

    render() {
        return (
            <div className={classes.container}>
                {this.getFormPageHeader()}
                <div className={classes.content}>
                    {this.state.loading || this.state.loadingManagedCountries ?
                        <Spinner/>
                        : <GeneralFormComponent dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                                                formTitle={this.GroupFormTitle}
                                                fields={this.state.formFields}
                                                formSchema={this.GroupSchema}
                                                submitButton={this.submitButton}
                                                cancelButton={this.cancelButton}
                                                processing={this.state.processing}/>
                    }
                </div>
            </div>
        );
    }

    getQueryParam = () => {
        const queryValues = queryString.parse(this.props.location.search);
        const facilityTypeToCall: any = (queryValues.type) ? queryValues.type : facilityTypes.ALL;

        return facilityTypeToCall;
    }

    async componentDidMount() {
        const {
            countryStore, facilityGroupStore,facilityAreaStore
        } = this.props;

        await countryStore.getUserManagedCountries();


        if (this.props.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
            this.isEgypt = true;
        }
        Promise.all([
            facilityAreaStore.getFacilityAreas(countryStore.managedCountries)
        ]).then(() => {
            this.updateStateWithFacilityAreasData();
        });
        this.setState({
            selectedLang: this.isNew && this.isEgypt
                ? languageCodes.arabic : languageCodes.english,
        }, () => {
            this.setState({
                formFields: this.getFOrmFields(),
            });
        });
        this.submitButton = this.getSubmitButton();
        this.setState({
            loadingManagedCountries: false,
        });
        if (!this.isNew) {


            const {facilityGroupStore}=this.props;
                Promise.all([
                    facilityGroupStore.getFacilityGroupById(this.GroupId, this.state.selectedLang),
                ]).then(() => {
                    this.updateStateWithGroupData();

                }).catch(() => {
                this.setState({
                    loading: false,
                });
            });
        }
    }

    getFacilityGroup = (langCode: string) => {
        this.setState({
            loading: true,
        });
        const {
            countryStore, facilityGroupStore,
        } = this.props;
        facilityGroupStore.getFacilityGroupById(this.GroupId, langCode)
        this.props.facilityAreaStore.getFacilityAreas(countryStore.managedCountries)
            .then(() => {
                this.updateStateWithGroupData();
                this.updateStateWithFacilityAreasData()
                this.dropdownLanguages!.selectedLang = langCode;
                this.setState({
                    selectedLang: langCode,
                });
            }).catch(() => {
            this.setState({
                loading: false,
            });
        });
    };
}

export default withRouter(AddEditFacilityGroup);
